import { IColumnsType } from "./types";

export function hasData(columns: IColumnsType[]): boolean {
  if (!columns) {
    return false;
  }
  return columns?.some((col) => col?.fieldName);
}
